<script setup>
import { useI18n } from 'vue-i18n';

defineProps({
  tabs: { type: Array, default: () => [] },
  modelValue: { type: String, default: 'para_enviar' },
  isLoading: { type: Boolean, default: false },
  refreshLabel: { type: String, default: '' },
});

const emit = defineEmits(['update:modelValue', 'refresh']);
const { t } = useI18n();
</script>

<template>
  <header
    class="flex min-h-[57px] items-center justify-between border-b border-[#E0E7EB] bg-white px-5 font-[Roboto] shadow-[0_2px_4px_rgba(0,0,0,0.08)]"
  >
    <div
      role="tablist"
      :aria-label="t('REAL_ESTATE_COMMISSION_SUPPORT.ARIA.TABS')"
      class="flex h-12 items-stretch"
    >
      <button
        v-for="tab in tabs"
        :id="`commission-support-tab-${tab.id}`"
        :key="tab.id"
        type="button"
        role="tab"
        :aria-selected="String(modelValue) === String(tab.id)"
        class="h-12 !rounded-none border-b-2 font-[Roboto] text-base font-bold leading-[22px] outline-none transition-colors"
        :class="[
          tab.id === 'para_enviar' ? 'w-[118px]' : 'w-[101px]',
          String(modelValue) === String(tab.id)
            ? 'border-[#01988C] text-[#01988C]'
            : 'border-transparent text-[#464F53] hover:text-[#01988C]',
        ]"
        @click="emit('update:modelValue', tab.id)"
      >
        {{ tab.label }}
      </button>
    </div>
    <div class="flex items-center gap-5 font-[Roboto] text-base">
      <button
        type="button"
        class="flex items-center gap-2 !text-base !leading-[22px] font-bold text-[#464F53] outline-none hover:text-[#01988C] disabled:cursor-not-allowed disabled:opacity-50"
        :disabled="isLoading"
        @click="emit('refresh')"
      >
        {{ t('REAL_ESTATE_COMMISSION_SUPPORT.ACTIONS.REFRESH') }}
        <span
          class="i-lucide-refresh-cw size-5 text-[#01988C]"
          :class="isLoading ? 'animate-spin' : ''"
          aria-hidden="true"
        />
      </button>
      <span v-if="refreshLabel" class="text-[#74848B]">
        {{ refreshLabel }}
      </span>
    </div>
  </header>
</template>
